import Vue from 'vue'
import globalConfig from 'init/global.config'
import globalStore from 'init/global-store'
import { hostsConfig } from 'init/config'
import { isMobileDevice } from 'util/browser-utils'
import Listbox from 'objects/listbox/listbox'
import ReviewFilters from 'components/reviews-list/review-filters'
import reviewsListConfig from 'widgets/reviews-list/reviews-list-widget.config'
import reviewsStore from 'store/reviews-store'
import SearchField from 'objects/form/search-field'
import { SortOption } from 'services/api-service'
import { ssoCreateReview, ssoGetLoggedInDataForReview } from 'services/sso-service'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { Source } from 'store/submission-store'

import withRender from './reviews-list-utilities.html'
import './reviews-list-utilities.scss'

export default withRender(Vue.extend({
  data() {
    return {
      filterStore: reviewsStore.filterStore,
      reviewsStore,
      submissionStore,
      store: globalStore,
      toggleFiltersOn: false
    }
  },
  components: {
    'tt-listbox': Listbox,
    'tt-review-filters': ReviewFilters,
    'tt-search-field': SearchField
  },
  computed: {
    appliedFilterOptions() {
      return this.filterStore.appliedFilters
    },
    hasSearchTerm() {
      return this.reviewsStore.trimmedSearchTerm.length > 0
    },
    hideWriteReview() {
      return reviewsListConfig.hideWriteReview
    },
    numFilters() {
      return this.filterStore.filters.length
    },
    isLaunchingWriteReview() {
      return submissionStore.isLaunchingWriteReview
    },
    sortBy() {
      return this.reviewsStore.sort
    },
    sortField() {
      const sortBy = this.reviewsStore.sort
      return {
        model: sortBy,
        label: this.$msg(`reviewsList.sortBy.${sortBy}`),
        options: reviewsListConfig.sortOptions.map((option) => {
          return { value: option, label: this.$msg(`reviewsList.sortBy.${option}`) } as SortOption
        })
      }
    },
    showFilters() {
      return (this.showFiltersToggle && this.toggleFiltersOn) ||
        (!this.showFiltersToggle && this.numFilters > 1)
    },
    showFiltersToggle() {
      return this.numFilters > 1 && (
        (reviewsListConfig.toggleFiltersDesktop && !isMobileDevice()) ||
        (reviewsListConfig.toggleFiltersMobile && isMobileDevice())
      )
    },
    toggleFiltersText() {
      return this.$msg(this.toggleFiltersOn ? 'reviewsList.hideFilters' : 'reviewsList.showFilters')
    }
  },
  methods: {
    clearAllFilters() {
      this.filterStore.clearFilters()
    },
    onSort(value: string) {
      reviewsStore.sort = value
    },
    removeFilter(filter, value) {
      this.filterStore.removeFilterValue(filter, value)
    },
    toggleFilters() {
      this.toggleFiltersOn = !this.toggleFiltersOn
    },
    writeReview(e) {
      // if sso, this will be set back to false when ssoRegDone or loggedInDataFnDone is called
      submissionStore.isLaunchingWriteReview = true
      if (globalConfig.ssoEnabled) {
        if (globalConfig.isPurchaseReq()) {
          ssoCreateReview(this.store.sku, Source.INLINE)
        } else {
          ssoGetLoggedInDataForReview(this.store.sku, Source.INLINE)
        }
        return
      }
      submissionStore.startRevFlow(
        this.store.sku,
        hostsConfig.siteKey,
        { page: 'review-form', props: {} },
        { startAction: 'review', source: Source.INLINE },
        e.currentTarget
      )
      submissionLoader.load()
      submissionStore.isLaunchingWriteReview = false
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-list/reviews-list-utilities.ts